import { render } from "./MagazineSliderList.vue?vue&type=template&id=b98244dc"
import script from "./MagazineSliderList.vue?vue&type=script&lang=js"
export * from "./MagazineSliderList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__